import { IUsuarioEquipeVendas } from "../../../../Interfaces/Vendas/EquipeVendas/UsuarioEquipeVendas/UsuarioEquipeVendas";
import {
    AtualizaUsuarioEquipeVendasService,
    DesvincularUsuarioEquipeVendasService,
    ListarUsuarioEquipeVendaDesvinculadoService,
    ListarUsuarioEquipeVendasService,
    VincularUsuarioEquipeVendasService,
} from "../../../../Services/Vendas/EquipeVendas/UsuarioEquipeVendas/UsuarioEquipeVendas";
import { Controller } from "../../../Controller";

//vincular
export async function VincularUsuarioEquipeVendasController(
    requestBody: IUsuarioEquipeVendas
) {
    return Controller(VincularUsuarioEquipeVendasService(requestBody));
}
//desvincular
export async function DesvincularUsuarioEquipeVendasController(
    requestBody: IUsuarioEquipeVendas
) {
    return Controller(DesvincularUsuarioEquipeVendasService(requestBody));
}
//listar
export async function ListarUsuarioEquipeVendasController(
    idEquipeVendas: number
) {
    return Controller(ListarUsuarioEquipeVendasService(idEquipeVendas));
}
export async function ListarUsuarioEquipeVendaDesvinculadoController(
    idEquipeVendas: number
) {
    return Controller(
        ListarUsuarioEquipeVendaDesvinculadoService(idEquipeVendas)
    );
}
//atualizar
export async function AtualizaUsuarioEquipeVendasController(
    requestBody: IUsuarioEquipeVendas
) {
    return Controller(AtualizaUsuarioEquipeVendasService(requestBody));
}
